import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';

export default function Disclaimer() {
  return (
    <>
      <Navbar />
      <main className="pt-24 pb-16 md:pb-20">
        <div className="px-4 md:px-6 max-w-[800px] mx-auto">
          <nav className="text-xs text-foreground-500 mb-6" aria-label="Breadcrumb">
            <Link to="/" className="hover:text-foreground-900 cursor-pointer transition-colors">Home</Link>
            <span className="mx-2">/</span>
            <span className="text-foreground-700 font-medium">Disclaimer</span>
          </nav>

          <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-8">Disclaimer</h1>

          <div className="space-y-6 text-foreground-700 leading-relaxed text-sm">
            <p><strong>Ultimo aggiornamento:</strong> Luglio 2026</p>

            <h2 className="text-xl font-heading font-bold text-foreground-900 mt-4">Natura del Sito</h2>
            <p>
              itaobuyspread.pics è un portale informativo indipendente. Non siamo direttamente affiliati 
              con Taobao, Weidian o altri marketplace citati. I marchi e i nomi dei prodotti menzionati 
              appartengono ai rispettivi proprietari.
            </p>

            <h2 className="text-xl font-heading font-bold text-foreground-900 mt-8">Accuratezza delle Informazioni</h2>
            <p>
              Facciamo del nostro meglio per mantenere le informazioni accurate e aggiornate, ma non 
              possiamo garantire la completa accuratezza di tutti i contenuti. I prezzi, la disponibilità 
              e le caratteristiche dei prodotti possono variare. Ti consigliamo di verificare sempre 
              le informazioni direttamente con il venditore prima di effettuare un acquisto.
            </p>

            <h2 className="text-xl font-heading font-bold text-foreground-900 mt-8">Link Esterni</h2>
            <p>
              Il nostro sito contiene link a siti web di terze parti, incluso Kaspreadsheet. Non abbiamo 
              alcun controllo sul contenuto di questi siti e non siamo responsabili per eventuali problemi 
              derivanti dal loro utilizzo. I link esterni sono forniti esclusivamente per comodità 
              dell&apos;utente.
            </p>

            <h2 className="text-xl font-heading font-bold text-foreground-900 mt-8">Responsabilità</h2>
            <p>
              itaobuyspread.pics non si assume alcuna responsabilità per eventuali perdite o danni 
              derivanti dall&apos;utilizzo delle informazioni presenti sul sito o dall&apos;acquisto di prodotti 
              tramite i link forniti. Ogni acquisto è una decisione personale dell&apos;utente.
            </p>

            <div className="mt-8">
              <Link to="/" className="text-sm font-medium text-primary-600 hover:text-primary-700 cursor-pointer transition-colors">
                &larr; Torna alla Home
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: 'Disclaimer - Itaobuy Spreadsheet',
            url: 'https://itaobuyspread.pics/disclaimer',
            description: 'Disclaimer di itaobuyspread.pics. Informazioni sulla natura del sito, accuratezza dei contenuti e limitazioni di responsabilità.',
            inLanguage: 'it',
            dateModified: '2026-07-14',
          }),
        }}
      />
    </>
  );
}